<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <transition
          name="fade"
          mode="out-in"
          appear
          :duration="500"
      >
        <component
            v-bind:is="current"
            @to-selecting-payment="selectPayment"
            @to-make-payment="toMakingPayment"
            v-bind="data"
        >
        </component>
      </transition>
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Instalments from '@/components/policies/Instalments';
import MakePayment from '@/components/buy/MakePayment';
import BranchSelectionReview from '@/components/policies/BranchSelectionReview';
import axios from 'axios';

export default {
  name: 'InstalmentPayment',
  components: {
    BreadCrumb, Default, Instalments, MakePayment, BranchSelectionReview,
  },
  metaInfo: {
    title: 'Pay Instalment',
  },
  data(vm) {
    return {
      breadcrumbs: [
        {
          text: 'My Policies',
          disabled: false,
          to: { name: 'MyPolicies' },
        },
        {
          text: 'My Policy',
          disabled: false,
          to: { name: 'SinglePolicy', params: { policyNo: vm.$route.params.policyNo } },
        },
        {
          text: 'Pay Instalment',
          disabled: true,
          to: { name: 'InstalmentPayment', params: { policyNo: vm.$route.params.policyNo } },
        },
      ],
      current: this.scanObject(this.$route, 'query.type', '') === 'instalment' ? Instalments : BranchSelectionReview,
      data: { renewal: { batchId: null } },
      gettingBatchId: true,
    };
  },
  mounted() {
    this.$root.$on('nav-back-to', (data) => {
      this.current = data.currentTab;
    });
    const params = {
      quoteId: this.$route.params.quoteId,
      batchNo: this.$route.params.batchNo,
    };
    this.$store.dispatch('renewal/fetchQuotation', params).then(() => {
      this.getBachNo();
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    selectPayment(data) {
      this.current = Instalments;
    },
    toMakingPayment(data) {
      this.data = data;
      this.current = MakePayment;
    },
    getBachNo() {
      axios.post('/customer/quotation/extension/policy', {
        batchNo: this.$route.params.batchNo, origin: 'P',
      }).then((response) => {
        this.data = { renewal: { batchId: response.data.data.batchId } };
        this.gettingBatchId = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  & > * {
    transition-duration: 100ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(.6,.15,.35,.8);
  }

}

$delay: 60ms;
$delayStep: 60ms;

.fade-enter,
.fade-leave-to {
  & > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
  & > * {
    &:nth-child(2) {
      transition-delay: $delay;
    }
    &:nth-child(3) {
      transition-delay: $delay + $delayStep;
    }
  }
}
.fade-leave-active {
  & > * {
    &:nth-child(1) {
      transition-delay: $delay + $delayStep;
    }
    &:nth-child(2) {
      transition-delay: $delay;
    }
  }
}
</style>
